import React from 'react';
import { TableContainer } from '../common';

export const MESSAGES = {
    title: 'Listado de grupos de acceso',
    created: 'El grupo de acceso ha sido creado correctamente',
    edited: 'El grupo de acceso ha sido editado correctamente',
    deleted: 'El grupo de acceso ha sido eliminado correctamente',
    deleteConfirmation: group =>
        `¿Estas seguro de que queres eliminar el grupo de acceso ${group.group}?`,
};


const COLUMNS = [
    {
        id: 'group',
        label: 'Grupo de acceso',
        minWidth: 100,
        hidden: {
            xsDown: true,
        },
    },
    {
        id: 'entraIdGroupId',
        label: 'ID de Entra ID',
        minWidth: 100,
        hidden: {
            xsDown: true,
        },
    }
];

export const ENTITY_PROPS = {
    entityName: 'grupo acceso',
    endpoint: 'groups',
    path: '/home/accessGroups',
};

const AccessGroupsTable = () => {
    return <TableContainer entityProps={ENTITY_PROPS} messages={MESSAGES} columns={COLUMNS} />;
};

export default AccessGroupsTable;
